import React, {useState} from 'react';
import {useStores} from "../../stores/Context";
import styles from "./CreateForm.module.scss";
import BtnSecondary from "../../boiteAOutils/BtnSecondary";
import ModalPrimary from "../../boiteAOutils/ModalPrimary";

export const FormConfiguration = ({text}) => {
    const {createWidgetStore, niveauxIndicateurStore} = useStores();

    const handleBackCreateWidgetHome = () => {
        createWidgetStore.resetCreateWidget();
        niveauxIndicateurStore.cleanup();
    }

    return (
        <BtnSecondary onClick={handleBackCreateWidgetHome}>
            { text ? text : "Annuler" }
        </BtnSecondary>
    );
};

// Alias historique conservé pour les formulaires de phidgets qui importent
// encore ce composant. Il délègue au comportement unique de retour/annulation
// afin d’éviter deux implémentations de navigation divergentes.
export const BackCreateWidgetHome = ({text}) => (
    <FormConfiguration text={text || "Annuler"}/>
);

export const BoutonSupprimerWidget = ({idWidget, widgetName, typeWidget, className}) => {
    const {uiStore, widgetStore, createWidgetStore} = useStores();
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState(false);

    const removeWidget = (idWidget) => {
        widgetStore.removeWidgetAvailable(idWidget);
        setModalShow(false);
        uiStore.closeCreationMode();
        createWidgetStore.closePanelNiveaux();
    }

    const modalRemoveWidget = (idWidget) => {
        setModalData(idWidget)
        setModalShow(true)
    }

    return (
        <>
            <button
                className={className}
                type={"button"}
                onTouchEnd={(ev) => {
                    modalRemoveWidget(idWidget);
                    ev.preventDefault();
                }}
                style={{
                    color: "var(--SEIZO-dark, #002335)",
                    display: "inline-flex",
                    padding: "10px 2px",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                    borderBottom: "2px solid var(--SEIZO-rouge, #F82121)",
                }}
                onClick={() => modalRemoveWidget(idWidget)}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M3.30907 16.1505L2.71824 4.33398H17.2824L16.6916 16.1505C16.6118 17.7471 15.294 19.0007 13.6953 19.0007H6.30532C4.7067 19.0007 3.3889 17.7471 3.30907 16.1505Z"
                        stroke="#F82121" strokeWidth="2"/>
                    <path
                        d="M6.83301 4H13.1663V3C13.1663 1.89543 12.2709 1 11.1663 1H8.83301C7.72844 1 6.83301 1.89543 6.83301 3V4Z"
                        stroke="#F82121" strokeWidth="2"/>
                    <path d="M0.833008 4.16602H19.1663" stroke="#F82121" strokeWidth="2"/>
                    <path d="M12.5 9.16602V13.3327" stroke="#F82121" strokeWidth="2"/>
                    <path d="M7.5 9.16602V13.3327" stroke="#F82121" strokeWidth="2"/>
                </svg>
                Supprimer
            </button>

            {
                modalShow ? (
                    <ModalPrimary
                        textTitle={'Êtes-vous sur de vouloir supprimer ce Phidget ?'}
                        textComment={"Si ce Phidget est présent sur le niveau flash, il sera supprimé également !"}
                        textBtnValidate={"Oui, supprimer le Phidget"}
                        textBtnCancel={"Non, revenir"}
                        onCancel={() => setModalShow(false)}
                        onValidate={() => removeWidget(idWidget)}
                    />
                ) : null
            }
        </>
    );
};

export const WidgetTitre = ({titre}) => {
    return (
        <div className={styles.WidgetTitre}>{titre}</div>
    );
};

export const TitreConfigurerPhidget = ({titre = "Configurer phidget"}) => {
    return (
        <div className={styles.TitreConfigurerPhidget}>{titre}</div>
    );
};

export default FormConfiguration;
